import useTestId from '@ori/testid-generator';
import { LastAddedItemMethod } from '@ori-events/basket-updated';
import type { MouseEvent, FC } from 'react';

import {
  BubbleWrapper,
  Details,
  Image,
  ImagePlaceholder,
  ImageWrapper,
  Name,
  Points,
  Price,
  Quantity,
  Shade,
  Shopping,
} from './styles';
import { type BubbleProps } from './types';
import { useTranslations } from '../../hooks/useTranslations';
import { TestId } from '../../types';

function ignoreClickEvent(event: MouseEvent<HTMLElement>) {
  event.preventDefault();
  event.stopPropagation();
}

export const Bubble: FC<BubbleProps> = ({ code, image, methodType, name, points, price, quantity }) => {
  const { getTestId } = useTestId();
  const { formatMessage } = useTranslations();
  const { BUY_FOR_MONEY, BUY_FOR_POINTS } = LastAddedItemMethod;

  return (
    <BubbleWrapper
      data-testid={getTestId(TestId.Popup)}
      onClick={ignoreClickEvent}
    >
      <ImageWrapper>
        {image ? (
          <Image
            src={image}
            alt="product"
          />
        ) : (
          <ImagePlaceholder />
        )}
      </ImageWrapper>
      <Details>
        <Name>{name}</Name>
        <Shade>{code}</Shade>
        <Shopping>
          <Quantity>
            {formatMessage('quantity')}: {quantity}
          </Quantity>
          {methodType === BUY_FOR_MONEY && <Price>{price}</Price>}
          {methodType === BUY_FOR_POINTS && <Points>{points}</Points>}
        </Shopping>
      </Details>
    </BubbleWrapper>
  );
};
